import { Component } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import styles from './GroupUsers.scss';
import { Link } from 'react-router';
import SearchContainer from 'common/containers/SearchContainer/SearchContainer';
import Part11Indicator from 'common/components/Part11Indicator/Part11Indicator';
import { loadUsers, sortOptions } from 'part11/actions/users';
import { setFilterOptions, setSortOptions, setSearchPlaceholderText } from 'common/actions/searchContainerActions';

const filterOptions = [
    { displayName: 'All Users', gqlName: 'all' },
    { displayName: 'Only Group Members', gqlName: 'only' },
    { displayName: 'Non Group Members', gqlName: 'non' }
];

const TableHeader = () => {
    return (
        <div className={styles.row} data-cy="GroupUsers">
            <span className={styles.title}>
                Display Name
            </span>
            <span className={styles.item}>
                Email
            </span>
            <span className={styles.item}>
                Member of Group
            </span>
            <span className={styles.actionLabel}>
                <span className={styles.actionLabelText}>
                    Add / Remove
                </span>
                <Part11Indicator className={styles.part11Icon} />
            </span>
        </div>
    );
};

const User = (props) => {
    const {
        user, group, addUserToGroup, removeUserFromGroup
    } = props;
    const userAction = user.isGroupMember ? removeUserFromGroup : addUserToGroup;
    const userPath =  `/admin/users/${user.id}`;

    return (
        <div className={styles.row} data-cy="GroupUsers-User">
            <Link to={userPath} className={styles.title} data-cy="GroupUsers-displayName">
                { user.displayName }
            </Link>
            <span className={styles.item} data-cy="GroupUsers-emailAddress">
                { user.emailAddress }
            </span>
            <span className={styles.item} data-cy="GroupUsers-isGroupMember">
                { user.isGroupMember ? 'Yes' : 'No'}
            </span>
            <span className={styles.actionLink} onClick={() => userAction(user, group)} data-cy="GroupUsers-onClick">
                { user.isGroupMember ? `Remove ${user.firstName} from Group` : `Add ${user.firstName} to Group` }
            </span>
        </div>
    );
};

export class GroupUsers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            shouldFilterUsers: false,
            usersFilterValue: null
        };
    }

    componentDidMount() {
        this.props.setSearchPlaceholderText('Search users by name and email');
        this.props.setFilterOptions(filterOptions);
        const { institutionId } = this.props;
        let query = { ...this.props.location.query };
        query.reset = true;
        this.props.loadUsers(institutionId, null, query, true);
        this.props.setSortOptions(sortOptions);
    }

    componentWillReceiveProps(nextProps) {
        const currentLocation = this.props.location;
        const nextLocation = nextProps.location;
        const filterField = lodash.get(nextLocation.query, 'filter', null);

        if (filterField !== null) {
            this.setState({
                shouldFilterUsers: true,
                usersFilterValue: filterField
            });
        }

        if (!lodash.isEqual(currentLocation.query, nextLocation.query)) {
            const { institutionId } = this.props;
            let query = { ...nextLocation.query };
            lodash.set(query, 'filter', null);
            query.reset = true;
            query.offset = 0;
            query.limit = this.props.availableUsers.length;
            this.props.loadUsers(institutionId, null, query, true);
        }
    }

    getUsers() {
        const { group, users } = this.props;
        const groupUsersById = lodash.keyBy(group.users, user => user.id);
        
        const formattedUsers = lodash.values(users).map((availableUser) => {
            const isGroupMember = groupUsersById[availableUser.id] ? true : false;
            let updatedUser = availableUser;
            lodash.set(updatedUser, 'isGroupMember', isGroupMember);

            if (this.state.shouldFilterUsers) {
                switch (this.state.usersFilterValue) {
                    case 'only':
                        return updatedUser.isGroupMember ? updatedUser : null;
                    case 'non':
                        return !updatedUser.isGroupMember ? updatedUser : null;
                    case 'all':
                        return updatedUser;
                }
            }

            return updatedUser;
        });

        return lodash.compact(formattedUsers);
    }

    render() {
        const users = this.getUsers();

        return (
            <div className={styles.container} data-cy="GroupUsers-render">
                <div className={styles.searchContainer}>
                    <SearchContainer />
                </div>
                <section className={styles.listWrapper}>
                    <TableHeader />
                    { users.map((user, index) => {
                        return <User {...this.props} user={user} key={index + user.id} />;
                    })}
                </section>
            </div>
        );
    }
}

export default connect((state) => {
    const placeholderText =  lodash.get(state, 'app.search.placeholderText', '');
    const filterOptions = lodash.get(state, 'app.search.filterOptions', []);
    const sortOptions = lodash.get(state, 'app.search.sortOptions', []);
    const users = lodash.get(state, 'users', {});
    return {
        placeholderText,
        filterOptions,
        sortOptions,
        users   
    };
}, {
    loadUsers,
    setSearchPlaceholderText,
    setFilterOptions,
    setSortOptions,
})(GroupUsers);
